import React, { useContext } from "react";
import { IdentifierMappingContext } from "../IdentifierMappingContext";
import { FetchBoundary } from "../../common/FetchBoundary";
import { Tab, Tabs } from "@mui/material";
import { PharmaciesTab } from "./PharmaciesTab";
import { MappingRequestTab } from "./MappingRequestsTab";
import { displayBalance, formatPharmacyGroupName } from "../../utils/Helpers";
import MixpanelService from "../../utils/MixpanelService";

export const PharmacyGroupDetails = () => {
  const {
    coveredEntity340bId,
    coveredEntityNames,
    pharmacyGroupDetailsFetcher,
    pharmacyGroupTab,
    setPharmacyGroupTab,
  } = useContext(IdentifierMappingContext);

  const pharmacyGroupDetails = pharmacyGroupDetailsFetcher.data?.pharmacy_group;

  return (
    <div className="bg--white border--rounded p-3" style={{ minHeight: "75vh" }}>
      <div className="mb-3 t--lg">Pharmacy Group Details</div>
      <FetchBoundary {...pharmacyGroupDetailsFetcher}>
        {pharmacyGroupDetails ? (
          <div className="my-b t--500">
            {coveredEntityNames[coveredEntity340bId]?.toUpperCase()} -{" "}
            {formatPharmacyGroupName(pharmacyGroupDetails.name).toUpperCase()}
          </div>
        ) : null}

        {pharmacyGroupDetails ? (
          <>
            <div style={{ borderBottom: "1px #dee5eb solid" }} className="mt-3 w--full">
              <Tabs
                value={pharmacyGroupTab}
                onChange={(e, newValue) => {
                  MixpanelService.track(
                    newValue == "pharmacies"
                      ? "esp_horizon_ad_pharmacies"
                      : "esp_horizon_mgn_id_identifiers"
                  );
                  setPharmacyGroupTab(newValue);
                }}
              >
                <Tab
                  label={
                    <div className="flex align-items-center">
                      Pharmacies
                      <div className="pharmacy-num ml-2">
                        {pharmacyGroupDetails.pharmacies.length}
                      </div>
                    </div>
                  }
                  value="pharmacies"
                />
                <Tab
                  disabled={pharmacyGroupDetails.mapping_request_count == 0}
                  label={
                    <div className="flex align-items-center">
                      Mapping Requests
                      <div className="pharmacy-num ml-2">
                        {displayBalance(pharmacyGroupDetails.mapping_request_count)}
                      </div>
                    </div>
                  }
                  value="pending_requests"
                />
              </Tabs>
            </div>
            {pharmacyGroupTab === "pharmacies" ? (
              <PharmaciesTab pharmacyGroupDetails={pharmacyGroupDetails} />
            ) : null}
            {pharmacyGroupTab === "pending_requests" ? (
              <MappingRequestTab pharmacyGroupDetails={pharmacyGroupDetails} />
            ) : null}
          </>
        ) : null}
      </FetchBoundary>
    </div>
  );
};
